module.exports = __webpack_public_path__ + "img/logo.cb589d59.png";